export class ResponseVM {
  [key: string]: string | boolean | undefined;
  key: string;
  value: string | boolean;
  isSelected?: boolean;

  constructor(key: string, value: string | boolean, isSelected?: boolean) {
    this.key = key;
    this.value = value;
    this.isSelected = isSelected;
  }
}
